import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataTypeComponent } from '../../data-type-component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DepositsIn24hThresholdOverrideService } from './deposits-in-24h-threshold-override.service';
import { Action } from './deposits-in-24h-threshold-override.model';

@Component({
  selector: 'app-deposits-in-24h-threshold-override',
  templateUrl: './deposits-in-24h-threshold-override.component.html',
  styleUrls: ['./deposits-in-24h-threshold-override.component.scss'],
  standalone: false,
})
export class DepositsIn24hThresholdOverrideComponent extends DataTypeComponent implements OnInit {
  fg: UntypedFormGroup;
  currencyCode: string;
  playerId: number;
  success: boolean = false;
  updatingInProgress: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private service: DepositsIn24hThresholdOverrideService,
    private changesDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {}

  override setRowData(entity: any) {
    this.currencyCode = entity?.currencyCode;
    this.playerId = entity.details?.playerId;
    this.initialize();
  }

  private initialize() {
    this.service.get(this.playerId).subscribe((d) => {
      this.fg = this.fb.group({
        active: [d.active, Validators.required],
        value: [this.currencyCode + ' ' + (d.value?.split(' ')[1] || '0.00')],
        freeze: [d.actions?.includes(Action.FREEZE_ACCOUNT)],
        depositBlock: [d.actions?.includes(Action.BLOCK_DEPOSIT)],
      });
      this.changesDetector.detectChanges();
      this.fg.disable();
    });
  }

  update() {
    this.updatingInProgress = true;
    const rawValue = this.fg.getRawValue();
    this.service
      .update(this.playerId, {
        active: rawValue.active,
        value: rawValue.value,
        actions: []
          .concat(rawValue.freeze ? [Action.FREEZE_ACCOUNT] : [])
          .concat(rawValue.depositBlock ? [Action.BLOCK_DEPOSIT] : []),
      })
      .subscribe(
        () => {
          this.toggleEditMode();
          this.fg.disable();
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 2000);
          this.updatingInProgress = false;
        },
        () => {
          this.success = false;
          this.updatingInProgress = false;
        }
      );
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.fg.enable();
    } else {
      this.initialize();
    }
  }
}
